import dayjs from 'dayjs';
import { stateOptions } from '../commonStateTaxData';

const customParseFormat = require('dayjs/plugin/customParseFormat');

dayjs.extend(customParseFormat);

export const stepOneInitialQuestions = [
  {
    id: 'employee_first_name_middle_initial',
    title: 'First name and middle initial (Line 1)',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_last_name',
    title: 'Last name (Line 1)',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number (Line 2)',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address (Line 1)',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town (Line 1)',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State (Line 1)',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code (Line 1)',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
];

export const filingStatusInitialQuestion = [
  {
    id: 'filing_status',
    title: 'Filing status (Line 3)',
    question_type: 'multiple_choice',
    is_required: true,
    options: [
      {
        codeValue: 'single',
        shortName: 'Single',
      },
      {
        codeValue: 'married',
        shortName: 'Married',
      },
      {
        codeValue: 'married_withhold_at_higher_single_rate',
        shortName:
          'Married, but withhold at higher single rate, or married filing separately',
      },
    ],
  },
];

export const getWorksheetInitialQuestions = (year = dayjs().year()) => [
  {
    id: 'dependents',
    title:
        `Dependents: Enter the number of dependents you will claim on your ${year} federal return. (Line E)`,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'dependents_under_age_6',
    title:
        `Dependents: Enter the number of these dependents who are under the age of 6 as of December 31, ${year}. (Line F)`,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
];

export const getYear = (version = '') => {
  const date = dayjs(version, 'M_D_YY');
  const currentYear = dayjs().year();
  const year = date.isValid() ? date.year() + 1 : currentYear;
  return Math.min(year, currentYear);
};

export const additionalAmountInitialQuestion = [
  {
    id: 'additional_amount',
    title: 'Additional amount, if any, to withhold from each paycheck (Line 6)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];

export const stateOfDomicileInitialQuestion = [
  {
    id: 'state_of_domicile',
    title: 'State of domicile:',
    question_type: 'dropdown',
    options: stateOptions,
  },
];
